import Vue from 'vue';

let roundTo = ( number, afterDot = 2 ) => {
  if (isNaN(number)) return number;
  return Math.round((Number(number) + Number.EPSILON) * Math.pow(10, afterDot)) / Math.pow(10, afterDot);
};

Vue.prototype.$roundTo = roundTo;

export default roundTo;
